import cx from 'classnames'
import { TraceSection } from '@/console/api/types'
import { TRACE_STAGES, hasExpectedTraceLayout, traceSectionAnchor, traceSectionBadge, traceSectionMeta, traceSectionState } from './traceView'
import styles from './trace.module.css'

const SHORT: Record<string, string> = { rows: '', empty: '0', error: '실패', skipped: '생략' }

/** LOGISPRD-13035 — 15구간 한 줄 지도. 칸을 누르면 그 구간으로 이동하고 펼친다(`TraceSectionList` 가 hash 이동을 받아 연다). */
export const TraceSectionMap = ({ sections, onJump }: { sections: TraceSection[]; onJump: (key: string) => void }): JSX.Element => (
  <>
    <nav className={styles.map} aria-label="구간 지도">
      {sections.map((section, i) => {
        const state = traceSectionState(section)
        const badge = traceSectionBadge(section)
        return (
          <a
            key={section.key}
            href={`#${traceSectionAnchor(section.key)}`}
            className={cx(styles.cell, styles[state])}
            title={`${i + 1}. ${traceSectionMeta(section.key).label} — ${badge.label}`}
            aria-label={`${i + 1}. ${traceSectionMeta(section.key).label} — ${badge.label}`}
            onClick={(e) => {
              e.preventDefault()
              onJump(section.key)
            }}
          >
            {i + 1}
            <em>{state === 'rows' ? `${section.rows.length}행` : SHORT[state]}</em>
          </a>
        )
      })}
    </nav>
    {hasExpectedTraceLayout(sections) ? (
      <div className={styles.stages} aria-hidden="true">
        {TRACE_STAGES.map((stage) => (
          <span key={stage.label} style={{ gridColumn: `span ${stage.span}` }}>
            {stage.label}
          </span>
        ))}
      </div>
    ) : null}
    <div className={styles.legend}>
      <span><i className={styles.rows} />행 있음</span>
      <span><i className={styles.empty} />데이터 없음 · 아직 그 단계 전</span>
      <span><i className={styles.error} />조회 실패 · 그 구간만</span>
      <span><i className={styles.skipped} />조회 생략 · 주문 없음</span>
    </div>
  </>
)
